import SolarPowerOutlinedIcon from "@mui/icons-material/SolarPowerOutlined";
//import AddHomeWorkOutlinedIcon from "@mui/icons-material/AddHomeWorkOutlined";
import GroupOutlinedIcon from "@mui/icons-material/GroupOutlined";
//import PersonAddAlt1OutlinedIcon from "@mui/icons-material/PersonAddAlt1Outlined";
import AssignmentLateOutlinedIcon from "@mui/icons-material/AssignmentLateOutlined";
//import ConstructionOutlinedIcon from "@mui/icons-material/ConstructionOutlined";
import DevicesIcon from "@mui/icons-material/Devices";
import ConstructionOutlinedIcon from "@mui/icons-material/ConstructionOutlined";
import SmsOutlinedIcon from "@mui/icons-material/SmsOutlined";
import AnalyticsOutlinedIcon from "@mui/icons-material/AnalyticsOutlined";
import ManageHistoryOutlinedIcon from "@mui/icons-material/ManageHistoryOutlined";
import QueryStatsOutlinedIcon from "@mui/icons-material/QueryStatsOutlined";
import SettingsRemoteOutlinedIcon from "@mui/icons-material/SettingsRemoteOutlined";
import ElectricMeterOutlinedIcon from "@mui/icons-material/ElectricMeterOutlined";
//import InsightsOutlinedIcon from "@mui/icons-material/InsightsOutlined";
import DynamicFormOutlinedIcon from "@mui/icons-material/DynamicFormOutlined";
import InsertLinkOutlinedIcon from "@mui/icons-material/InsertLinkOutlined";

const admin = {
  id: "group-admin",
  title: "관리자",
  admin: true,
  type: "group",
  children: [
    {
      id: "plantlist",
      title: "발전소 관리",
      type: "item",
      url: "/admin/plant",
      icon: SolarPowerOutlinedIcon,
      breadcrumbs: true,
    },

    {
      id: "outputctrl",
      title: "출력제어 관리",
      type: "item",
      url: "/admin/outputctrl",
      icon: DynamicFormOutlinedIcon,
      breadcrumbs: true,
    },

    {
      id: "shuntschedule",
      title: "출력제어 일정",
      type: "item",
      url: "/admin/shuntschedule",
      icon: DynamicFormOutlinedIcon,
      breadcrumbs: true,
    },

    {
      id: "minusplant",
      title: "마이너스발전소",
      type: "item",
      url: "/admin/plant/minus",
      icon: AssignmentLateOutlinedIcon,
      breadcrumbs: false,
    },
    // {
    //   id: "plantcreate",
    //   title: "발전소 등록",
    //   type: "item",
    //   url: "/admin/plant/create",
    //   icon: AddHomeWorkOutlinedIcon,
    //   breadcrumbs: true,
    // },

    {
      id: "userlist",
      title: "사용자 관리",
      type: "item",
      url: "/admin/user",
      icon: GroupOutlinedIcon,
      breadcrumbs: true,
    },

    {
      id: "devicelist",
      title: "장치 관리",
      type: "item",
      url: "/admin/device",
      icon: DevicesIcon,
      breadcrumbs: true,
    },

    {
      id: "rtulist",
      title: "위즈비 관리",
      type: "item",
      url: "/admin/wizbeertu",
      icon: ManageHistoryOutlinedIcon,
      breadcrumbs: true,
    },

    {
      id: "wizbee_circuit",
      title: "원격차단 제어관리",
      type: "item",
      url: "/admin/circuit",
      icon: SettingsRemoteOutlinedIcon,
      breadcrumbs: true,
    },

    {
      id: "facility",
      title: "유지관리",
      type: "item",
      url: "/admin/facility",
      icon: ConstructionOutlinedIcon,
      breadcrumbs: true,
    },

    {
      id: "alertsms",
      title: "문자전송기록",
      type: "item",
      url: "/admin/alertsms",
      icon: SmsOutlinedIcon,
      breadcrumbs: true,
    },

    {
      id: "compareanalysis",
      title: "발전소 비교",
      type: "item",
      url: "/admin/compareanalysis",
      icon: AnalyticsOutlinedIcon,
      breadcrumbs: false,
    },

    // {
    //   id: "compareanalysis2",
    //   title: "발전량 선택일",
    //   type: "item",
    //   url: "/admin/compareanalysis2",
    //   icon: AnalyticsOutlinedIcon,
    //   breadcrumbs: false,
    // },

    {
      id: "guarantee",
      title: "보증발전시간",
      type: "item",
      url: "/admin/guarantee",
      icon: QueryStatsOutlinedIcon,
      breadcrumbs: false,
    },

    {
      id: "externalmapping",
      title: "외부연계",
      type: "item",
      url: "/admin/externalmapping",
      icon: InsertLinkOutlinedIcon,
      breadcrumbs: false,
    },
    // {
    //   id: "guaranteehoursgrp",
    //   title: "보증발전시간(그룹)",
    //   type: "item",
    //   url: "/admin/guaranteehoursgrp",
    //   icon: QueryStatsOutlinedIcon,
    //   breadcrumbs: false,
    // },
    // {
    //   id: "guaranteeplant",
    //   title: "보증발전시간(연차)",
    //   type: "item",
    //   url: "/admin/guaranteeplants",
    //   icon: QueryStatsOutlinedIcon,
    //   breadcrumbs: false,
    // },

    // {
    //   id: "ivcurve",
    //   title: "I-V Curve 분석",
    //   type: "item",
    //   url: "/admin/ivcurve",
    //   icon: ElectricMeterOutlinedIcon,
    //   breadcrumbs: false,
    // },

    // {
    //   id: "monthly_report",
    //   title: "월간 보고서",
    //   type: "item",
    //   url: "/admin/monthlyreport",
    //   icon: InsightsOutlinedIcon,
    //   breadcrumbs: false,
    // },

    // {
    //   id: "usercreate",
    //   title: "사용자 등록",
    //   type: "item",
    //   url: "/admin/user/create",
    //   icon: PersonAddAlt1OutlinedIcon,
    //   breadcrumbs: true,
    // },

    // {
    //   id: "facility",
    //   title: "유지 관리",
    //   type: "item",
    //   url: "/admin/facility",
    //   icon: ConstructionOutlinedIcon,
    //   breadcrumbs: true,
    // },
  ],
};

export default admin;
